import React from 'react';

const Home = () => {
    return (
    <div>
        <div className='homeDiv'>
            <h1>Welcome to strangers things!</h1>
            <p>Feel free to post listings on this trading site</p>
        </div>
    </div>
    )
}

export default Home;